import { useEffect, useState } from "react";
import axios from "axios";
import { Alert, Button, Form, Modal, Table } from "react-bootstrap";
import { ROLE_OPTIONS } from "../helpers/roles";

/**
 * Довідник ролей KeyCRM: API KeyCRM не віддає назв ролей, тож назву задаємо тут;
 * «Права» — яка роль застосунку видається співробітнику з цією роллю CRM.
 */
export default function KeycrmRolesModal({ show, roles, onHide, onSaved }) {
    const [rows, setRows] = useState([]);
    const [error, setError] = useState("");
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (show) {
            setRows(roles.map((r) => ({ roleId: r.roleId, name: r.name || "", appRole: r.appRole })));
            setError("");
        }
    }, [show, roles]);

    const update = (roleId, patch) => setRows((list) => list.map((r) => (r.roleId === roleId ? { ...r, ...patch } : r)));

    const save = async () => {
        setSaving(true);
        try {
            const res = await axios.put("/api/users/keycrm-roles", { roles: rows }, { withCredentials: true });
            onSaved?.(res.data);
        } catch (e) {
            setError(e.response?.data?.error || "Помилка збереження");
        } finally {
            setSaving(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Ролі KeyCRM</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="small text-muted">
                    KeyCRM не передає назви ролей через API — вкажіть їх тут один раз. Нові ролі з&apos;являються
                    автоматично після «Оновити з CRM».
                </p>
                {error ? <Alert variant="danger" className="py-2">{error}</Alert> : null}
                <Table size="sm" className="align-middle mb-0">
                    <thead>
                        <tr>
                            <th style={{ width: 50 }}>ID</th>
                            <th>Назва в CRM</th>
                            <th>Права в застосунку</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((r) => (
                            <tr key={r.roleId}>
                                <td className="text-muted">{r.roleId}</td>
                                <td>
                                    <Form.Control size="sm" value={r.name} onChange={(e) => update(r.roleId, { name: e.target.value })} />
                                </td>
                                <td>
                                    <Form.Select size="sm" value={r.appRole} onChange={(e) => update(r.roleId, { appRole: e.target.value })}>
                                        {ROLE_OPTIONS.map((o) => (
                                            <option key={o.value} value={o.value}>
                                                {o.label}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Закрити
                </Button>
                <Button variant="dark" onClick={save} disabled={saving}>
                    Зберегти
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
